import { useEffect } from "react";
import { useNavigate, Link } from "react-router-dom";
import { Video, ArrowRight } from "lucide-react";
import { Button } from "@/components/ui/button";

/** Studio has been repurposed — streaming & clip generation removed.
 *  Auto-redirects to AI Creator Studio (the specialist creator assistant).
 *  Users landing on /studio see a brief "moved" screen for 2s then jump. */
export default function StudioPage() {
  const nav = useNavigate();
  useEffect(() => {
    const t = setTimeout(() => nav("/chat/creator", { replace: true }), 1800);
    return () => clearTimeout(t);
  }, [nav]);

  return (
    <div className="mx-auto flex min-h-[60vh] max-w-2xl flex-col items-center justify-center px-6 text-center" data-testid="studio-redirect">
      <div className="flex h-14 w-14 items-center justify-center rounded-full bg-accent/15 text-accent">
        <Video className="h-6 w-6" />
      </div>
      <h1 className="mt-6 font-display text-3xl tracking-tight sm:text-4xl">Studio has moved</h1>
      <p className="mt-3 max-w-md text-muted-foreground">
        We&apos;ve rebuilt Studio as the <strong>AI Creator Studio</strong> — hooks, TikTok/Reels scripts,
        posting calendars and brand-deal pitches. Taking you there now…
      </p>
      <div className="mt-6 flex flex-wrap justify-center gap-2">
        <Button asChild className="bg-accent text-accent-foreground hover:bg-accent/90" data-testid="studio-go-creator">
          <Link to="/chat/creator">Open AI Creator Studio <ArrowRight className="ml-1 h-4 w-4" /></Link>
        </Button>
        <Button asChild variant="outline" data-testid="studio-go-dashboard">
          <Link to="/dashboard">Back to dashboard</Link>
        </Button>
      </div>
    </div>
  );
}
